const getOptions = (
  enumData: Record<string, string | number>,
  labelData: Record<string, string>
) => {
  return Object.entries(enumData).map(([key, value]) => ({
    label: labelData[value as string],
    value,
  }))
}

// 团队成员角色
export enum UserPermissionEnum {
  SuperAdmin = 'superadmin',
  Admin = 'admin',
  User = 'user',
  Anonymous = 'anonymous',
}

// 团队成员角色
export const UserPermissionItems = [
  // {
  //   label: '超级管理员',
  //   value: UserPermissionEnum.SuperAdmin,
  // },
  {
    label: '管理员',
    value: UserPermissionEnum.Admin,
  },
  {
    label: '成员',
    value: UserPermissionEnum.User,
  },
]

// 菜单key
export enum MenuKeyEnum {
  /**
   * 待审核
   */
  Review = 'review',
  /**
   * 素材库
   */
  MaterialLibrary = 'materialLibrary',
}

// 素材审核状态
export enum ReviewStatusEnum {
  /**
   * 已审核
   */
  IsPass = 'is_review',
  /**
   * 未审核
   */
  NoReview = 'no_review',
  /**
   * 未通过
   */
  NoPass = 'no_pass',
}

// 素材审核状态
const ReviewLabel = {
  [ReviewStatusEnum.IsPass]: '已审核',
  [ReviewStatusEnum.NoReview]: '未审核',
  [ReviewStatusEnum.NoPass]: '未通过',
}

// 素材审核状态
export const ReviewOptions = getOptions(ReviewStatusEnum, ReviewLabel)

// 标签类型
export enum TagTypeEnum {
  /**
   * 工作区
   */
  Workspace = 'workspace',
  /**
   * AI
   */
  AI = 'AI',
  /**
   * 用户
   */
  User = 'user',
}

// 未定义 id
export enum NotDefinedEnum {
  /**
   * 文件夹-未分类-ID
   */
  NOT_FOLDER = -1,
  /**
   * 标签组-未分组-ID
   */
  NOT_TAG_GROUP = 0,
}

// 版权状态
export enum CopyrightStatusEnum {
  /**
   * 商用授权
   */
  Commercial = 'commercial',
  /**
   * 版权自用
   */
  Oneself = 'oneself',
  /**
   * 免费商用
   */
  Free = 'free',
  /**
   * 版权未知
   */
  Unknown = 'unknown',
}

// 版权状态
const CopyrightLabel = {
  [CopyrightStatusEnum.Commercial]: '商用授权',
  [CopyrightStatusEnum.Free]: '免费商用',
  [CopyrightStatusEnum.Oneself]: '自有',
  [CopyrightStatusEnum.Unknown]: '未知',
}

// 版权状态
export const CopyrightOptions = getOptions(CopyrightStatusEnum, CopyrightLabel)

// 错误码
export enum ErrorCodeEnum {
  /**
   * 权限不足
   */
  NotAuthorized = 10031,
  /**
   * Token 过期、无效
   */
  TokenInvalid = 10032,
  /**
   * 用户错误
   */
  UserError = 10033,
  /**
   * 缺少 token
   */
  MissingToken = 10034,
}
